import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { App } from './App';
import { AuthProvider } from './auth';
import { ConfirmVisit } from './pages/ConfirmVisit';
import { PortalApp } from './portal/PortalApp';
import { captureViewAs } from './viewAs';
import './styles.css';
import './more.css';
import './forms.css';
import './refine.css';
import './portal/portal.css';

// Contractors use /portal (their own sign-in and session); everything else is the office app.
const path = window.location.pathname;
const portal = path === '/portal' || path.startsWith('/portal/');
// An office user opened the portal from Portal users to look at it as a contractor.
if (portal) captureViewAs();

// A data router around the app's own <Routes>, so forms can hold back navigation
// while they have unsaved changes (see UnsavedChanges).
const router = createBrowserRouter(
  [
    {
      path: '*',
      element: (
        <AuthProvider realm={portal ? 'portal' : 'staff'}>
          {portal ? <PortalApp /> : <App />}
        </AuthProvider>
      ),
    },
  ],
  { basename: portal ? '/portal' : undefined },
);

// A contractor confirming a visit from a link in a text or email: no sign-in, no app around it.
const confirming = path === '/portal/confirm';

createRoot(document.getElementById('root')!).render(
  <StrictMode>{confirming ? <ConfirmVisit /> : <RouterProvider router={router} />}</StrictMode>,
);
